import { render, staticRenderFns } from "./SurveyModal_comp.vue?vue&type=template&id=761c4e94&scoped=true&"
import script from "./SurveyModal_comp.vue?vue&type=script&lang=js&"
export * from "./SurveyModal_comp.vue?vue&type=script&lang=js&"
import style0 from "./SurveyModal_comp.vue?vue&type=style&index=0&id=761c4e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c4e94",
  null
  
)

export default component.exports